import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { ConstantsService } from '../../services/constants.service';
import { BaseService } from './../../services/base.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ara-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit, OnChanges {

  @Input() routesFlag;
  @Input() reportRoutes;
  isExpand: any = false;
  expandSubMenu: boolean = false;
  loggedInUserJSON: any;
  isHSEAdvisor: boolean = false;
  minheight: number = 120;
  minheightfor: number = 80;

  constructor(private baseService: BaseService,
    private translate:TranslateService) { }

  ngOnInit() {
    // check role - if it's HSEAdvisor then display reports side nav
    const loggedInUser = this.baseService.getItemFromSession(ConstantsService.commonConstants.loggedInUser);
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    // if (this.loggedInUserJSON.UserRoles.length > 0) {
    //   const roles = this.loggedInUserJSON.UserRoles.find((item) => item.RoleName === ConstantsService.Roles.HSEAdvisor);
    //   if (roles !== undefined && roles.RoleName === ConstantsService.Roles.HSEAdvisor) {
    //     this.isHSEAdvisor = true;
    //   }
    // }
      this.baseService.translatorListener.subscribe((data) => {
          this.translate.use(data);
      });
  }
  // TO change the height of sidenav dynamicallly
  sidebarheight() {
    if (this.routesFlag.length > 5) {
      const height = {
        'min-height.px': this.minheight
      };
      return height;
    } else {
      const height = {
        'min-height.px': this.minheightfor
      };
      return height;
    }
  }
  /**
   * Funtion for toggle common side bars side navigation
   */
  toggleSideBar(toggelValue) {
    if (toggelValue === ConstantsService.commonConstants.opensideBar) {
      this.isExpand = true;
    } else {
      this.isExpand = false;
    }
  }

  /**
   * Funtion for toggle sub menu of navigation
   */
  toggleSubMenu(toggelSubmenuValue) {
    if (toggelSubmenuValue === ConstantsService.commonConstants.opensubmenu) {
      this.expandSubMenu = true;
    } else {
      this.expandSubMenu = false;
    }
  }

  /**
  * Funtion to set routes and report routes in base service
  */
  ngOnChanges() {
    this.baseService.setTopNavigationRoutes(this.routesFlag, this.reportRoutes);
  }
  routeClicked() {
    if (window.innerWidth < 823) {
      let toggle: HTMLElement = document.getElementsByClassName('navbar-toggle')[0] as HTMLElement;
      toggle.click();
    }
  }
}
